import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { SurveyComponent } from "../../components/views/SurveyComponent";

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:cod" element={<SurveyComponent />} />
        <Route path="/" element={<SurveyComponent />} />
        <Route
          path="/pickers"
          element={
            <SurveyComponent
              nameEncuesta={"PickitPickers"}
              guidIdEncuesta="C9DA6D6B-0F76-4AC1-91B6-47882450893E"
            />
          }
        />
        <Route
          path="/buyer"
          element={
            <SurveyComponent
              nameEncuesta={"PickitBuyer"}
              guidIdEncuesta="2203B675-2B8B-468B-9116-802B2562595E"
            />
          }
        />
        <Route
          path="/punto"
          element={
            <SurveyComponent
              nameEncuesta={"PickitPunto"}
              guidIdEncuesta="0CB97690-64B6-4CDF-B85A-5A3A797E3FE2"
            />
          }
        />
        <Route
          path="/seller"
          element={
            <SurveyComponent
              nameEncuesta={"PickitSeller"}
              guidIdEncuesta="1E692247-EBE5-400D-94AF-0453AB5CAD11"
            />
          }
        />
        <Route
          path="/sodimacempresasuy"
          element={
            <SurveyComponent
              nameEncuesta={"SodimacEmpresasUy"}
              guidIdEncuesta="74A33395-E88B-4E90-8A45-EF4DE550C4A0"
            />
          }
        />
        <Route
          path="/oncosaludbot"
          element={
            <SurveyComponent
              nameEncuesta={"OncosaludBot"}
              guidIdEncuesta="0739BC93-754B-43C0-B94C-C9248B1EF3BA"
            />
          }
        />
        <Route
          path="/oncosalud"
          element={
            <SurveyComponent
              nameEncuesta={"Oncosalud"}
              guidIdEncuesta="1D28D111-F2F0-48A2-908B-4896AC71C647"
            />
          }
        />
        <Route
          path="/osinergmin"
          element={
            <SurveyComponent
              nameEncuesta={"Osinergmin"}
              guidIdEncuesta="F3F58F4A-68DA-4E0B-8401-38EACC380423"
            />
          }
        />
        <Route
          path="/alpina"
          element={
            <SurveyComponent
              nameEncuesta={"Alpina"}
              guidIdEncuesta="974EDB71-E99E-41B2-8F53-368CCCAF04BA"
            />
          }
        />
        <Route
          path="/alicorpbo"
          element={
            <SurveyComponent
              nameEncuesta={"AlicorpBO"}
              guidIdEncuesta="85772787-912D-4E1E-AE90-AAEAA68E7508"
            />
          }
        />
        <Route
          path="/diners"
          element={
            <SurveyComponent
              nameEncuesta={"Diners"}
              guidIdEncuesta="926C1654-496F-4F76-9349-6841DBDB14C2"
            />
          }
        />
        <Route
          path="/banbif"
          element={
            <SurveyComponent
              nameEncuesta={"Banbif"}
              guidIdEncuesta="61A9877E-3527-4AAA-9F3A-8C25E58A1C11"
            />
          }
        />
        <Route
          path="/movistarchile"
          element={
            <SurveyComponent
              nameEncuesta={"MoviChile"}
              guidIdEncuesta="CC7E7CEA-6936-4AB7-B4F0-601B68ABDB47"
            />
          }
        />
        <Route
          path="/liquidaciondesueldos"
          element={
            <SurveyComponent
              nameEncuesta={"LiquidacionDeSueldos"}
              guidIdEncuesta="A6C50900-1CDA-4239-B84D-1DEFA6F2116A"
            />
          }
        />
        <Route
          path="/cais"
          element={
            <SurveyComponent
              nameEncuesta={"Cais"}
              guidIdEncuesta="D6B0748D-2EA6-4251-9B2B-0CC59114A21E"
            />
          }
        />
        <Route
          path="/rrhh"
          element={
            <SurveyComponent
              nameEncuesta={"RRHH"}
              guidIdEncuesta="084C82B5-B1EB-4940-A9C3-50F924D9433F"
            />
          }
        />
        <Route
          path="/caruso"
          element={
            <SurveyComponent
              nameEncuesta={"Caruso"}
              guidIdEncuesta="BBCCFC9B-D74E-4566-851B-E8776AF892C2"
            />
          }
        />
        <Route
          path="/sodimacarg"
          element={
            <SurveyComponent
              nameEncuesta={"SodimacArg"}
              guidIdEncuesta="C6C4E67D-1180-45D3-B310-524E3A9EBD94"
            />
          }
        />
        <Route
          path="/sodimacuy"
          element={
            <SurveyComponent
              nameEncuesta={"SodimacUy"}
              guidIdEncuesta="521C91DF-E00D-4F97-8C66-3CCB37735294"
            />
          }
        />
        <Route
          path="/sodimacempresas"
          element={
            <SurveyComponent
              nameEncuesta={"SodimacEmpresas"}
              guidIdEncuesta="A817A595-2DDD-4AE1-BFD5-AD0B0CC2DA3A"
            />
          }
        />
        <Route
          path="/kolectorcatastro"
          element={
            <SurveyComponent
              nameEncuesta={"KolectorCatastro"}
              guidIdEncuesta="4CF81B0A-C52A-4DBD-82AC-EE6A2B99DC08"
            />
          }
        />
        <Route
          path="/kolectoripj"
          element={
            <SurveyComponent
              nameEncuesta={"KolectorIPJ"}
              guidIdEncuesta="E0E28AF4-81BC-4479-B17D-27DA8EC0E148"
            />
          }
        />
        <Route
          path="/kolectorregistropropiedad"
          element={
            <SurveyComponent
              nameEncuesta={"KolectorRegistroPropiedad"}
              guidIdEncuesta="A278796C-B0AE-45C4-AC83-77F4CE1E8788"
            />
          }
        />
        <Route
          path="/kolectorregistrocivil"
          element={
            <SurveyComponent
              nameEncuesta={"KolectorRegistroCivil"}
              guidIdEncuesta="20B01A24-38C1-4BEB-8E8F-8512A096FFAE"
            />
          }
        />
        <Route
          path="/kolectorropyce"
          element={
            <SurveyComponent
              nameEncuesta={"KolectorROPYCE"}
              guidIdEncuesta="DAFA845E-3E06-4FD5-AAD4-04AF828361F5"
            />
          }
        />
        <Route
          path="/try"
          element={
            <SurveyComponent
              nameEncuesta={"Try"}
              guidIdEncuesta="EF27198F-8334-4681-97E9-508A2114C581"
            />
          }
        />
        <Route
          path="/tuentiarg"
          element={
            <SurveyComponent
              nameEncuesta={"TuentiArg"}
              guidIdEncuesta="D96BE159-E8EF-42F9-8781-C0305642295B"
            />
          }
        />
        <Route
          path="/moviindividuos"
          element={
            <SurveyComponent
              nameEncuesta={"MoviIndividuos"}
              guidIdEncuesta="84C6F7F5-D709-4BE5-8443-A5ED594A37F6"
            />
          }
        />
        <Route
          path="/puntopickit"
          element={
            <SurveyComponent
              nameEncuesta={"Punto"}
              guidIdEncuesta="0CB97690-64B6-4CDF-B85A-5A3A797E3FE2"
            />
          }
        />
        <Route
          path="/encuesta/:pNameEncuesta/:pGuidIdEncuesta"
          element={<SurveyComponent isEncuestaGenerica={true} />}
        />
      </Routes>
    </BrowserRouter>
  );
}
